import React, { useState, useEffect } from "react";
import { Modal, Form, Input } from "antd";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { useDispatch, useSelector } from "react-redux";
import { Language, DeleteTwoTone } from "@material-ui/icons";
import { uniq, find, clone, filter } from "lodash";
import LCButton from "../../styles/LCButton";
import { updateDomain } from "../../../store/actions/domainActions";
import { CSVLink } from "react-csv";
import moment from "moment";

export const ManageCompetitorsModal = () => {
  const dispatch = useDispatch();
  const currentDomain = useSelector((state) => state.domains.currentDomain);
  const domains = useSelector((state) => state.domains.domains);
  const keywords = useSelector((state) => state.keywords.keywords);
  const isLoading = useSelector((state) => state.config.disableButton);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [targets, setTargets] = useState([]);
  const [targetForm] = Form.useForm();

  useEffect(() => {
    if (domains && domains.length > 0) {
      const current = find(domains, (domain) => {
        return domain._id === currentDomain._id;
      });
      setTargets(current.targets);
    }
  }, [domains]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onFinish = (values) => {
    let addTargets = clone(targets);
    const domainName = values.targetName.replace("www.", "").toLowerCase();
    addTargets.push(domainName);
    dispatch(
      updateDomain(
        currentDomain,
        { targets: uniq(addTargets) },
        setIsModalVisible
      )
    );
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const removeTarget = (target) => {
    const unRemovedTargets = filter(targets, (noTarget) => {
      return noTarget !== target;
    });
    dispatch(
      updateDomain(
        currentDomain,
        { targets: unRemovedTargets },
        setIsModalVisible
      )
    );
  };

  const data = keywords.map((key) => {
    return {
      Target_Keywords_Ranking: key.rank,
      Target_keyword: key.keyword,
      searchEngine: key.searchEngine,
      scrapedAt: key.scrapedAt,
      country: key.country,
      Target_Competitors: currentDomain.targets,
    };
  });
  let domain = currentDomain.name;
  let nameDomain = domain.replaceAll(".", "_");
  const filename = `Target-Competitors-${nameDomain}-${moment().format(
    "YYYY-MM-DD HH:mm:ss"
  )}`;
  return (
    <>
      <CSVLink
        data={data}
        filename={`${filename}.csv`}
        className="btn btn-primary"
        target="_blank"
      >
        <LCButton type="primary" addMargin as="button" size="large">
          DownLoad Target Competitors Report
        </LCButton>
      </CSVLink>

      <LCButton type="secondary" as="button" onClick={showModal} size="large">
        Manage Targets
      </LCButton>

      <Modal
        title="Manage Targets"
        visible={isModalVisible}
        onOk={() => targetForm.submit()}
        onCancel={handleCancel}
        keyboard={false}
        maskClosable={false}
        okText="Add"
        okButtonProps={{
          loading: isLoading,
        }}
        cancelButtonProps={{
          loading: isLoading,
        }}
        footer={[
          <LCButton type="primary" as="button" onClick={handleCancel} addMargin>
            Cancel
          </LCButton>,
          <LCButton
            type="secondary"
            as="button"
            onClick={() => targetForm.submit()}
            addMargin
          >
            Save
          </LCButton>,
        ]}
      >
        <Table className="ant-table-thead">
          <Tbody className="ant-table-tbody text-center">
            {targets.map((target) => {
              return (
                <Tr className="ant-table-row ant-table-row-level-0">
                  <Td className="ant-table-cell text-left">{target}</Td>
                  <Td className="ant-table-cell">
                    <DeleteTwoTone
                      onClick={() => {
                        removeTarget(target);
                      }}
                    />
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
        <br />
        <Form
          form={targetForm}
          name="targetForm"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            style={{ marginBottom: "0px" }}
            name="targetName"
            label={false}
            rules={[
              {
                required: true,
                message: "Please a valid domain name is required.",
              },
              {
                pattern:
                  /^(([a-zA-Z]{1})|([a-zA-Z]{1}[a-zA-Z]{1})|([a-zA-Z]{1}[0-9]{1})|([0-9]{1}[a-zA-Z]{1})|([a-zA-Z0-9][a-zA-Z0-9-_]{1,61}[a-zA-Z0-9]))\.([a-zA-Z]{2,6}|[a-zA-Z0-9-]{2,30}\.[a-zA-Z]{2,3})$/g,
                message: "Domain format is not correct.",
              },
            ]}
          >
            <Input
              prefix={<Language className="mr-2" />}
              placeholder="Please enter domain name eg., (google.com)"
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
